<template>
    <div class="water-errorlog" >
        <div class="water-errorlog-title">
            <strong>
                错误日志
            </strong>
        </div>
        <div id="components-form-demo-advanced-search">
            <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
                <a-row :gutter="24">
                    <a-col :span="8">
                        <a-form-item v-bind="formItemLayout" label="投保单号">
                            <a-input
                                    v-decorator="[
                                        'proposalNo'
                                    ]"
                                    placeholder="投保单号"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item v-bind="formItemLayout" label="保单号">
                            <a-input
                                    v-decorator="[
                                        'policyNo'
                                    ]"
                                    placeholder="保单号"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item v-bind="formItemLayout" label="订单号">
                            <a-input
                                    v-decorator="[
                                        'orderNo'
                                    ]"
                                    placeholder="订单号"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item v-bind="formItemLayout" label="接口类型">
                            <a-select
                                    :allowClear="true"
                                    v-decorator="[
                                        'interfaceType'
                                    ]"
                                    placeholder="接口类型"
                            >
                                <a-select-option  v-for="(item,index) in interfaceEnum" :key="index" :value="item.codeValue">
                                   {{item.codeName}}
                                </a-select-option>
                            </a-select>

                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item v-bind="formItemLayout" label="开始时间">
                            <a-date-picker
                                    v-decorator="['startDateTime', {
                rules: [{ type: 'object', required: rulesOpen, message: '请选择时间!' }],
            }]"
                                    :disabled-date="disabledStartDate"
                                    show-time
                                    format="YYYY-MM-DD HH:mm:ss"
                                    style="width: 100%"
                                    @openChange="handleStartOpenChange"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item v-bind="formItemLayout" label="结束时间">
                            <a-date-picker
                                    v-decorator="['endDateTime', {
                rules: [{ type: 'object', required: rulesOpen, message: '请选择时间!' }],
            }]"
                                    :disabled-date="disabledEndDate"
                                    show-time
                                    :open="endOpen"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    style="width: 100%"
                                    @openChange="handleEndOpenChange"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24" :style="{ textAlign: 'right' }">
                        <a-button type="primary" html-type="submit">
                            查询
                        </a-button>
                        <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
                            重置
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>
            <div style="margin-top: 20px;">
                <div class="water-errorlog-button">
                    <a-button type="primary" :disabled="!hasSelected" :loading="loading.button" @click="reSave">
                        重发报文
                    </a-button>
                </div>
                <a-table
                        @change="pageChange"
                        :columns="columns"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                        :pagination="pagination"
                        :loading="loading.search"
                        :scroll="{
                            x:1200,
                            y:500
                        }"
                        :data-source="data"
                        rowKey="id"
                        class="components-table-demo-nested"
                        bordered >
                    <div slot="interfaceType" slot-scope="record,index,text" >
                        {{interfaceEnum.filter(item=>item.codeValue == record)[0].codeName}}
                    </div>
                    <a href="javascript:;" slot="action" slot-scope="record,text,index" @click="handleOk(index)">
                        查看错误日志/报文</a>
                </a-table>
                <a-modal v-model="visible" title="错误日志/报文" :width="1000">
                    <template slot="footer">
                        <a-button key="back" @click="handleCancel">
                            返回
                        </a-button>
                    </template>
                    <div style="overflow:hidden;width: 955px">
                        <div style="width: 545px;overflow: auto;float: left;height: 400px">
                            <h4>错误日志</h4>
                            <p s>
                                {{data && data[innerColumnsIndex] && data[innerColumnsIndex].errorContent}}
                            </p>
                        </div>
                        <div style="width: 400px;overflow: auto;float: right;height: 400px">
                            <h4>接口报文</h4>
                            <p>
                                {{data && data[innerColumnsIndex] && data[innerColumnsIndex].requestContent}}
                            </p>
                        </div>
                    </div>
                </a-modal>
            </div>
        </div>


    </div>
</template>
<script>
    import {post} from '@/http';
    import { notification } from 'ant-design-vue';
    import Table from '@/utils/table';
    export default {
        name:'errorlog',
        props:{
            url:String
        },
        data() {
            const innerColumns = [
                {
                    title: '错误日志',
                    dataIndex: 'errorContent',
                    scopedSlots: { customRender: 'errorContent' }
                },
                {
                    title: '接口报文',
                    dataIndex: 'requestContent',
                    width:200,
                },
            ];
            const columns = [
                {
                    title: '序号',
                    dataIndex: 'id',
                    width:100,
                    fixed:'left'
                },

                {
                    title: '订单号',
                    dataIndex: 'orderNo',
                    width:200
                },

                {
                    title: '投保单号',
                    dataIndex: 'proposalNo',
                    width:200
                },
                {
                    title: '保单号',
                    dataIndex: 'policyNo',
                    width:200
                },
                {
                    title: '接口类型',
                    dataIndex: 'interfaceType',
                    scopedSlots: { customRender: 'interfaceType' },
                    width:150
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    width:200
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    width:200
                },
                {
                    title: '更新时间',
                    width:202,
                    dataIndex: 'updateTime',
                },
                {
                    title: '操作',
                    width:202,
                    scopedSlots: { customRender: 'action' },
                    fixed:'right'
                }
            ];
            const interfaceEnum = Table.interfaceType;
            const formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 8 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
            };
            let data = [];
            let searchForm = {};
            let selectedRowKeys = [];
            let loading = {
                search:false,
                button:false,
            };
            let rulesOpen = true;
            let pagination = {
                current:1,
                total:0,
                pageSize:10,
                hideOnSinglePage:true,
            };
            let innerColumnsIndex = 0;
            return {
                data,
                columns,
                innerColumns,
                pagination,
                selectedRowKeys,
                loading,
                interfaceEnum,
                formItemLayout,
                searchForm,
                rulesOpen,
                innerColumnsIndex,
                endOpen:false,
                visible:false,
                form: this.$form.createForm(this, {
                    name: 'errorlog_search',
                }),
            };
        },
        created() {

        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            }
        },
        methods:{
            handleCancel() {
                this.visible = false;
            },
            handleOk(index){
                console.log(index);
                this.visible = true;
                this.innerColumnsIndex = index;
            },
            pageChange(pagination){
                this.loading.search = true;
                let url = this.url ? this.url : '/health/sdbao/errorlog';
                post(url + '/query',{
                    "pageNum": pagination.current,
                    "pageSize": pagination.pageSize,
                    ...this.searchForm
                })
                    .then((result)=>{
                        this.loading.search = false;
                        result = result.result;
                        if(result){
                            this.data = result.dataList;
                            this.pagination.total = result.total;
                            this.pagination.current = result.pageNumber;
                        }
                    })
                    .catch((err)=>{
                        this.loading.search = false;
                    });
            },
            handleSearch(e) {
                e.preventDefault();
                const values = this.form.getFieldsValue();
                if(!values.endDateTime && !values.startDateTime && (values.policyNo || values.proposalNo || values.orderNo)){
                    this.rulesOpen = false;
                }else {
                    this.rulesOpen = true;
                }
                this.$nextTick(() => {
                    this.form.validateFields((error, values) => {
                        if(!error){
                            let data = values;
                            data.startDateTime = data.startDateTime && data.startDateTime.format('x');
                            data.endDateTime = data.endDateTime && data.endDateTime.format('x');
                            this.searchForm = data;
                            this.pagination.current = 1;
                            this.pageChange(this.pagination);
                        }
                    });
                });

            },
            handleReset() {
                this.form.resetFields();
            },
            onSelectChange(selectedRowKeys){
                this.selectedRowKeys = selectedRowKeys;
            },
            reSave(){
                this.loading.button = true;
                let url = this.url ? this.url : '/health/sdbao/errorlog';
                post(url+'/send',{
                    id:this.selectedRowKeys
                })
                    .then((res)=>{
                        this.loading.button = false;
                        if(res.success){
                            notification.success({
                                message: '成功',
                                description: '重新发送报文到消费队列成功!',
                            });
                            this.pageChange(this.pagination);
                        }
                    })
                    .catch((err)=>{
                        this.loading.button = false;
                    });
            },
            disabledStartDate(startValue) {
                const endValue = this.form.getFieldValue('endDateTime');
                if (!startValue || !endValue) {
                    return false;
                }
                return startValue.valueOf() > endValue.valueOf();
            },
            disabledEndDate(endValue) {
                const startValue = this.form.getFieldValue('startDateTime');
                if (!endValue || !startValue) {
                    return false;
                }
                return startValue.valueOf() >= endValue.valueOf();
            },
            handleStartOpenChange(open) {
                if (!open) {
                    this.endOpen = true;
                }
            },
            handleEndOpenChange(open) {
                this.endOpen = open;
            },
        }
    };
</script>


<style scoped>
    .water-errorlog-title{
        text-align: center;
        font-size: 20px;
        margin: 20px 0;
    }
    .water-errorlog-button{
        margin: 10px 0;
    }
</style>